import type { UploadDocumentationBody } from '@si/types';
import { postForm } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

export function useUploadDocumentationPhoto({ projectId }: { projectId: string }) {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ formData }: { formData: FormData }) =>
      postForm<{ projectId: number }>({
        url: `/projects/${projectId}/documentation-files`,
        body: formData,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getDocumentationFiles(projectId),
      });
    },
  });

  const uploadDocumentationPhoto = useCallback(
    (params: UploadDocumentationBody) => {
      const formData = new FormData();
      formData.append('imageData', JSON.stringify(params));
      if (params.imageFile) {
        formData.append('imageFile', params.imageFile);
      }

      mutate({ formData });
    },
    [mutate]
  );

  return {
    uploadDocumentationPhoto,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
